import { Steps, type StepsProps } from 'antd'
import React, { type ReactNode } from 'react'
import './Stepper.less'

export type Step = { title: string; content?: ReactNode; route?: string }

export type StepperProps = {
  activeStep: number
  steps: Step[]
  browserHistory?: any
  onStepClick?: (e: number) => void
  allActiveSteps?: boolean
} & StepsProps

export function Stepper({
  activeStep,
  steps,
  responsive,
  onStepClick,
  allActiveSteps,
  ...props
}: StepperProps) {
  return (
    <div className="old-stepper">
      <Steps
        current={activeStep}
        labelPlacement="vertical"
        {...props}
        progressDot={responsive}
        className={`${responsive ? 'responsive-stepper' : ''}${
          allActiveSteps ? ' all-active-steps' : ''
        }'`}
      >
        {steps.map((step, index) => (
          // @ts-ignore
          <Steps.Step
            onClick={() => onStepClick && onStepClick(index)}
            key={step.title}
            title={!responsive ? step.title : null}
          />
        ))}
      </Steps>
    </div>
  )
}

export default Stepper
